import { AuthResponseStatus } from '@/enums/AuthResponseStatus';

export default class Response {
  public status: AuthResponseStatus = AuthResponseStatus.FAILED;
  public accessToken: string = '';
  public refreshToken: string = '';
  public messageEN: string = '';
  public messageNL: string = '';

  constructor(status: AuthResponseStatus, accessToken: string, refreshToken: string, messageEN = '', messageNL = '') {
    this.status = status;
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    this.messageEN = messageEN;
    this.messageNL = messageNL;
  }

  public static buildFailedResponse(messageEN: string, messageNL: string): Response {
    return new Response(AuthResponseStatus.FAILED, '', '', messageEN, messageNL);
  }
}
